import { MeetingSummaryHeaderPreset } from '../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'

const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

const clientAndAdvisorFollowUpTasks = { dev: '9xbrgp80b4ls6qbx', staging: '9xbrgp80b4ls6qbx', prod: 'cqkkd1xbz240b6b7' }
const followUpEmail = { dev: 'aur41tqdihe9u1kd', staging: 'dxq0qfghf7kekksd', prod: 'ekg2bcro6o85d6qw' }

export const MEETING_SUMMARY_HEADER_PRESETS: MeetingSummaryHeaderPreset[] = [
  { aiFeaturePresetId: clientAndAdvisorFollowUpTasks[env], label: 'Tasks', icon: 'bi-check2-square' },
  { aiFeaturePresetId: followUpEmail[env], label: 'Email', icon: 'bi-envelope-at' },
]
